import { useContext } from "react";
import DataVisualizationTypeContext from "../contexts/DataVisualizationTypeContext";

function useDataVisualizationType() {
  return useContext(DataVisualizationTypeContext);
}
export default useDataVisualizationType;
